import { createContext, useState, useEffect } from "react";
import axios from "axios";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true); // Estado de carga

  useEffect(() => {
    const API_URL =
      process.env.REACT_APP_API_URL || "https://check.gruponxt.com";

    const fetchUser = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/usuario`, {
          withCredentials: true,
        });
        setUser(response.data);
      } catch (error) {
        setUser(null); // Usuario no autenticado
      } finally {
        setIsLoading(false); // Finaliza el estado de carga
      }
    };

    fetchUser();
  }, []);

  return (
    <UserContext.Provider value={{ user, setUser, isLoading }}>
      {children}
    </UserContext.Provider>
  );
};
